import {React, useState} from "react";
import {PrimaryButton} from "../../elements/Buttons";
import {toast} from "react-toastify";
import {Input} from "../../elements/forms/Inputs";
import {baseHandleChange} from "../../elements/forms/Form";
import {retrieveRegistration} from "../../../api/summer_school";
import Alert from "../../elements/Alert";

export default function RetrieveRegistration() {

    const [data, setData] = useState({})
    const [apiData, setApiData] = useState({})
    const [errors, setErrors] = useState({}) // validation errors
    const [success, setSuccess] = useState(null)

    const title = "Summer School Anmeldung Finden"
    const successMessage = "Anmeldung gefunden. Wir haben Ihnen eine Email mit einem Link zum Fortsetzen der Anmeldung gesendet."
    const errorMessage = "Wir konnten keine Anmeldung mit dieser Email finden."

    const schema = {}

    async function onSubmit() {

        if (!data.email) return

        try {
            console.log(data)
            const newData = await retrieveRegistration(data)
            setApiData(newData)
            console.log(newData)

            if (newData.registration_found) {
                setSuccess(true)
                // toast.success(successMessage)
            } else {
                setSuccess(false)
                // toast.error(errorMessage)
            }

        } catch (e) {
            console.log(e)
            if (e.message !== "Validation failed") { // Don't show API error for validation failures
                toast.error("Fehler beim Absenden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.")
            }
            throw e
        }
    }

    function handleChange(evt) {
        baseHandleChange(evt, data, setData, errors, setErrors, schema)
    }

    return (

        <div className="max-w-4xl mx-auto px-4 py-4 sm:px-6 md:px-8">

            <div className="mx-auto grid grid-cols-1 gap-6 md:grid-flow-col-dense md:grid-cols-3">

                <div className="md:col-span-4 md:col-start-1">

                    <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>

                    {success === false && <Alert extraClassName="my-2" variant="danger">{errorMessage}</Alert>}
                    {success === true && <Alert extraClassName="my-2" variant="success">{successMessage}</Alert>}

                    <p className="mt-2 mb-1 text-sm text-gray-700">
                        Sie können hier eine bestehende Anmeldung abrufen:
                    </p>

                    <div className="inline-flex grid grid-cols-3 gap-2 items-end">
                        <Input
                            path="email"
                            label="Email"
                            className="sm:col-span-2"
                            onChange={handleChange}
                            errors={errors}
                            data={data}
                        />
                        <PrimaryButton onClick={onSubmit} label="Anmeldung abrufen"></PrimaryButton>
                    </div>

                </div>

            </div>

        </div>
    )
}
